import { resourceText } from 'src/app/shared/services/localization';
import { TenantService } from 'src/app/tenant/tenant.service';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { ProfileService } from 'src/app/shared/profile/profile/profile.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { AuthService } from '../account/auth.service';
import { Location } from '@angular/common';
import { User } from '../account/user.model';
import { AccountDeletionService, DeletionNotification } from '../../shared/services/account-deletion.service';

@Component({
    selector: 'app-my-profile',
    templateUrl: './my-profile.component.html',
    styleUrls: ['./my-profile.component.scss'],
    standalone: false
})
export class MyProfileComponent implements OnInit, AfterViewInit, OnDestroy {
  householdSetup = false;
  confirmDeletion = false;
  deletingAccount = false;
  accountDeleted = false;
  deletionError = '';
  deletionTakingLonger = false;
  deletionOptions = { email:false, sms:false };
  loadingDeletionOptions = false;
  deletionOptionsUnavailable = false;
  deletionNotification: DeletionNotification = 'none';
  private deletionNoticeTimer: ReturnType<typeof setTimeout> | null = null;
  async openDeletion() {
    if(this.deletingAccount)return;
    this.confirmDeletion=true;this.loadingDeletionOptions=true;this.deletionOptionsUnavailable=false;
    this.deletionOptions={email:false,sms:false};this.deletionNotification='none';
    try {
      this.deletionOptions=await this.deletion.options();
      this.deletionNotification=this.deletionOptions.email?'email':this.deletionOptions.sms?'sms':'none';
    } catch { this.deletionOptionsUnavailable=true; }
    finally { this.loadingDeletionOptions=false; }
  }
  async deleteAccount(mode: 'wait' | 'notify' = 'wait') {
    if (this.deletingAccount || this.accountDeleted) return;
    if(mode==='notify' && (this.loadingDeletionOptions || this.deletionNotification==='none'))return;
    this.deletingAccount = true; this.deletionError = '';
    this.clearDeletionNotice();
    this.deletionNoticeTimer = setTimeout(() => {
      this.deletionTakingLonger = true;
      this.deletionNoticeTimer = null;
    }, 15000);
    try {
      const receipt=await this.deletion.start(this.tenantService.getTenant(),mode==='notify'?this.deletionNotification:'none',this.userId);
      this.confirmDeletion=false;this.accountDeleted=true;
      try { localStorage.removeItem('CSBarcodeID'); } catch {}
      try { this.authService.logout(0); } catch {}
      this.globalService.currentUserId=null;
      this.globalService.fromRegistration=false;
      this.deletingAccount=false;
      // Both choices receive a visible confirmation regardless of whether the
      // church Home redirects to Calendar. Only the wait choice keeps polling.
      try {
        await this._router.navigate(['/'+this.tenantService.getTenant()+'/account-deletion'],{
          replaceUrl:true,state:{deletionReceipt:receipt}
        });
      } catch { /* The accepted-request fallback remains visible. */ }
    } catch {
      // A lost response cannot tell us whether the server completed deletion.
      this.deletionError = resourceText('WE_COULD_NOT_CONFIRM_THE_CHANGE_PLEASE_TRY_AGAIN');
      this.deletingAccount = false;
      return;
    } finally {
      this.clearDeletionNotice();
    }
  }
  private clearDeletionNotice() {
    if (this.deletionNoticeTimer !== null) clearTimeout(this.deletionNoticeTimer);
    this.deletionNoticeTimer = null;
    this.deletionTakingLonger = false;
  }

  ngOnDestroy() {
    this.clearDeletionNotice();
  }
  User: User = null;
  userId: string = null;
  constructor(
    public profileService: ProfileService,
    private authService: AuthService,
    private _router: Router,
    private route: ActivatedRoute,
    private globalService: GlobalService,
    private tenantService: TenantService,
    private _location: Location,
    private deletion: AccountDeletionService
  ) {}

  goHome() {
    if (this.deletingAccount) return;
    this.globalService.fromRegistration = false;
    this._router.navigate(['/' + this.tenantService.getTenant() + '/home']);
  }

  async ngOnInit() {

    this.householdSetup = this.route.snapshot.queryParamMap.get('setup') === 'household';
    this.globalService.isBack = false;
    this.userId = this.globalService.currentUserId;
    if (this.route.snapshot.queryParamMap.get('delete') === 'true') await this.openDeletion();
  }

  ngAfterViewInit() {
    setTimeout(() => {
    this.globalService.title.push(this.globalService.screenHeader);
    this.globalService.selectedOption = "MYPROFILE";    
    this.globalService.screenHeader = resourceText('MY_PROFILE_HOUSEHOLD');
    });
  }         
}
